export default class AnotherEquipment {
  Key;
  Type;
  SubType;
  Value;
  Title;
  Cards;
  Id;
}
